import environmentSvg from 'assets/icons/environment.svg';
import { BaseSelectMultiLevel } from 'lib/BaseSelect';
import { Environment } from 'components/common/types/Deal.types';
import { Option } from 'components/common/types/DropdownItem.types';

interface FilterChannelProps {
  selectedChannels?: Environment[];
  availableChannels: Environment[];
  changeFilters: (filters: { channels: Environment[] }) => void;
  isDisabled?: boolean;
}

const FilterChannel: React.FC<FilterChannelProps> = ({
  selectedChannels = [],
  availableChannels,
  changeFilters,
  isDisabled = false,
}) => {
  const handleChannelChange = (node: Option, checked: boolean): void => {
    let updatedChannels: Environment[];

    if (checked) {
      const foundChannel = availableChannels.find((c) => c.code === node.code);

      updatedChannels = [...selectedChannels, ...(foundChannel ? [foundChannel] : [])];
    } else {
      updatedChannels = selectedChannels.filter((channel) => channel.code !== node.code);
    }

    changeFilters({ channels: updatedChannels });
  };

  return (
    <BaseSelectMultiLevel
      options={availableChannels.map((option) => ({ ...option, selectable: true }))}
      value={selectedChannels.map((channel) => channel.code) || []}
      onChangeItem={handleChannelChange}
      isDisabled={isDisabled}
      dataTestId="channel-select"
      icon={environmentSvg}
      placeholder="Select channel"
      classNameWrapper="w-44"
      selectedLabel="Channel"
    />
  );
};

export default FilterChannel;
